import React from 'react'

import { Form } from 'react-form'

import { Toolbar } from 'primereact/toolbar'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

// wrappers for prime react form fields
import FieldInputTextarea from '../common/FieldInputTextarea'

const RejectReasonDialogFooter = ({ formApi }) => {
  return (
    <Toolbar>
      <div className="p-toolbar-group-left">
        <Button className={"p-button-danger"} label="Reject Candidate" icon="pi pi-times" onClick={formApi.submitForm} />
      </div>
    </Toolbar>
  )
}

const RejectReasonDialog = ({ rejectReason, rejectReasonFormSubmitted, isShowingRehectReasondDialog, closeRejectReason }) => {
  /* 
     values sets the form state. I'm binding to the props which is linked to redux so we can update the store and the form will be reflected
     this is useful when needed to clear the form or populating the form from another component
     onSubmit is called when the form has been submitted and has passed validation
     formApi properties can be found at https://react-form.js.org/#/
  */
  let validationRules = rejectReason.ValidationRules ? rejectReason.ValidationRules.$values : []
  return (
    <Form values={rejectReason} onSubmit={rejectReasonFormSubmitted}>
      {formApi => {
        let footer = <RejectReasonDialogFooter formApi={formApi}></RejectReasonDialogFooter>
        return (
          <Dialog visible={isShowingRehectReasondDialog} header="Reason for rejection" modal={true}
            footer={footer} onHide={closeRejectReason}>
            <div>
              <FieldInputTextarea rows={3} field={"RejectReason"} label={"Reject Reason"} tabindex="0" aria-label="Reject Reason" validationRules={validationRules} />
            </div>
          </Dialog>
        )
      }
      }
    </Form>
  )
}

export default RejectReasonDialog


// WEBPACK FOOTER //
// ./src/components/candidate/reject-reason-dialog.js